import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { cardCls } from "@/lib/labels";

export const LoyaltyCard = ({ loyalty }) => {
  const { progress, every, available } = loyalty;
  return (
    <div className={`${cardCls} relative overflow-hidden p-6`} data-testid="loyalty-card">
      <div className="mb-3 flex items-center justify-between">
        <p className="font-head font-bold text-white">مكافأة الإعلان المجاني</p>
        <Gift className="h-6 w-6 text-[var(--km-lilac)]" />
      </div>
      <p className="font-display text-4xl text-white" data-testid="loyalty-progress">{progress}/{every}</p>
      <div className="mt-3 flex gap-1.5" aria-hidden="true">
        {Array.from({ length: every }).map((_, i) => (
          <span key={i} className={`h-2.5 flex-1 rounded-full ${i < progress ? "bg-[var(--km-pink)]" : "bg-black/40"}`} />
        ))}
      </div>
      <p className="mt-3 text-sm text-purple-200/80">كل 8 إعلانات مدفوعة تتسلم = إعلان مجاني من 30 لـ 60 ثانية.</p>
      {available > 0 && (
        <Link to="/create-ad" className="font-head mt-4 inline-flex rounded-full bg-[var(--km-cyan)] px-4 py-2 text-sm font-bold text-[#0b0414]" data-testid="loyalty-redeem-link">
          عندك {available} إعلان مجاني، استخدمه دلوقتي
        </Link>
      )}
    </div>
  );
};
